<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet />
      <ion-tab-bar slot="bottom" id="app-tab-bar">
        <ion-tab-button tab="home" href="/page/home">
          <img
            style="height: 30px; width: 30px"
            src="../gama/home.png"
            alt=""
          />
          <ion-label>Belajar</ion-label>
        </ion-tab-button>
        <!-- <ion-tab-button tab="home" href="/page/home">
          <img
            style="height: 30px; width: 30px"
            src="../gama/invoice.png"
            alt=""
          />
          <ion-label>Pembelian</ion-label>
        </ion-tab-button> -->

        <ion-tab-button tab="halamanshort" @click.prevent="goToShorts">
          <img
            style="height: 30px; width: 30px"
            src="../gama/cinema.png"
            alt=""
          />
          <ion-label>Shorts</ion-label>
        </ion-tab-button>

        <!-- <ion-tab-button tab="halamanai" @click.prevent="goToAi">
          <img
            style="height: 30px; width: 30px"
            src="../assets/boot.svg"
            alt=""
          />
          <ion-label>Tanya.ai</ion-label>
        </ion-tab-button> -->


        <ion-tab-button tab="halamansetting" @click.prevent="goToSettings">
          <img
            style="height: 30px; width: 30px"
            src="../gama/male.png"
            alt="Settings"
          />
          <ion-label>Settings</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="logout" @click.prevent="logOut()">
          <img
            style="height: 30px; width: 30px"
            src="../gama/logut.png"
            alt=""
          />
          <ion-label>Logout</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup>
import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLabel,
  // IonIcon,
  IonPage,
  IonRouterOutlet,
  alertController,
} from "@ionic/vue";
// import { exit } from "ionicons/icons";
import { useRouter } from "vue-router";
import { getAuth, signOut } from "firebase/auth";

const auth = getAuth();
const router = useRouter();

const goToSettings = () => {
  router.push({ name: "halamansettingUser" });
};

const goToShorts = () => {
  router.push({ name: "halamanShortsUser" });
};

// const goToAi = () => {
//   router.push({ name: "halamanAiUser" });
// };


const logOut = async () => {
  const alert = await alertController.create({
    cssClass: "my-custom-class",
    header: "Confirm!",
    mode: "ios",
    message: "Confirm Logout?",
    buttons: [
      {
        text: "Cancel",
        role: "cancel",
        cssClass: "secondary",
        handler: () => {
          console.log("Confirm Cancel");
        },
      },
      {
        text: "Logout",
        handler: async () => {
          try {
            await signOut(auth);
            console.log("Logged out successfully");

            // Bersihkan semua data lokal
            localStorage.clear();
            sessionStorage.clear();

            // Redirect ke halaman login setelah logout
            router.push({ name: "login" }).then(() => {
              // Bersihkan riwayat sehingga pengguna tidak dapat kembali ke halaman sebelumnya
              router.go(0);
            });
          } catch (error) {
            console.error("Logout error", error);
          }
        },
      },
    ],
  });
  await alert.present();
};
</script>

<style scoped>
ion-tab-bar {
  position: relative;
  bottom: 0;
  width: 100%;
  height: 60px;
  --background: #f3f3f3;
}
ion-tab-bar ion-tab-button {
  font-size: 13px;
  --color-selected: var(--ion-color-primary);
}
ion-tab-bar ion-tab-button ion-icon {
  font-size: 1.5rem;
}
</style>
